<template>
  <div class="flex justify-start">
    <div class="max-w-[85%] rounded-2xl rounded-tr-md bg-indigo-500/20 p-4 animate-fade-in">
      <!-- Customer name -->
      <div class="flex items-center gap-2 mb-3">
        <div class="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
          <i class="pi pi-user text-white/70" />
        </div>
        <span class="text-white/90 text-sm font-medium">{{ card.fullName }}</span>
      </div>

      <!-- Next appointment -->
      <div v-if="card.nextAppointment" class="mb-3 px-3 py-2 rounded-xl bg-white/5 text-xs text-white/60">
        <div class="flex items-center gap-1.5 mb-1">
          <i class="pi pi-calendar text-[10px]" />
          <span>תור הבא</span>
        </div>
        <div class="text-white/80 text-sm">
          {{ card.nextAppointment.date }} | {{ card.nextAppointment.time }}
        </div>
        <div class="text-white/50 mt-0.5">{{ card.nextAppointment.services }}</div>
      </div>
      <div v-else class="mb-3 px-3 py-2 rounded-xl bg-white/5 text-xs text-white/50">
        אין תורים קרובים
      </div>

      <!-- Action buttons -->
      <div class="flex gap-2 items-center">
        <button
          class="rounded-full px-3 py-1.5 border border-white/20 text-white/70 text-xs hover:bg-white/10 transition-colors"
          @click="goToProfile"
        >
          דף לקוח
        </button>
        <button
          class="rounded-full flex items-center justify-center w-8 h-8 border border-green-500/40 bg-green-500/10 hover:bg-green-500/20 transition-colors"
          @click="openWhatsApp"
        >
          <i class="pi pi-whatsapp text-green-400 text-sm" />
        </button>
        <button
          class="rounded-full flex items-center justify-center w-8 h-8 border border-blue-500/40 bg-blue-500/10 hover:bg-blue-500/20 transition-colors"
          @click="callCustomer"
        >
          <i class="pi pi-phone text-blue-400 text-sm" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CustomerCardData } from '@app/api/admin/ai-api';
import { AdminRouteNames } from '@app/router/route-names';
import { useNavigation } from '@app/composables/navigation';
import { sendWhatsApp, openLinkNewTab } from '@torim-app/utils';
import { useDrawer } from '@torim-app/shared-components';

const props = defineProps<{
  card: CustomerCardData;
}>();

const { goTo } = useNavigation();
const { closeDrawer } = useDrawer();

const goToProfile = () => {
  goTo(AdminRouteNames.ClientProfile, { params: { id: props.card.customerId } });
  closeDrawer();
};

const openWhatsApp = () => {
  sendWhatsApp(props.card.phoneNumber);
};

const callCustomer = () => {
  openLinkNewTab(`tel:${props.card.phoneNumber}`);
};
</script>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.35s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
